import { CYCLE_DAY_TEST_START, CYCLE_DAY_TEST_END, CYCLE_DAY_TEST_UNDERLINE_START, CYCLE_DAY_TEST_UNDERLINE_END } from '../../../data/constants';
import { getLocalTodayString } from '../../../utils/dateFormat';

function CalendarDayMenuInfoBox({ ipData, date }) {
  const cycleDay = ipData?.cd;
  const isPredictedOvulation = ipData?.predictedOvulation;
  const isPredictedPeriod = ipData?.predictedPeriod;
  const isPeriodDay = ipData?.periodDay;

  // Check if the date is today
  const isToday = date === getLocalTodayString();

  if (!cycleDay) return null;

  // Determine if test is recommended (days 10-18)
  const isTestRecommended = cycleDay >= CYCLE_DAY_TEST_START && cycleDay <= CYCLE_DAY_TEST_END;

  // Determine if it's the peak window (days 12-15) - 2 tests per day
  const isPeakWindow = cycleDay >= CYCLE_DAY_TEST_UNDERLINE_START && cycleDay <= CYCLE_DAY_TEST_UNDERLINE_END;

  const testRecommendedStyle = isPeakWindow
    ? 'text-green-600 underline'
    : 'text-green-600';

  const testRecommendedText = isPeakWindow
    ? '2 tests per day'
    : '1 test per day';

  // Determine background color and border based on day type
  let bgColor = 'bg-white';
  let borderColor = 'border-gray-200';
  let textColor = 'text-gray-800';

  // Today overrides with blue styling
  if (isToday) {
    bgColor = 'bg-blue-50';
    borderColor = 'border-[#bfdbfe]';
  } else if (isPredictedOvulation) {
    bgColor = 'bg-purple-50';
    borderColor = 'border-purple-200';
    textColor = 'text-purple-800';
  } else if (isPredictedPeriod) {
    bgColor = 'bg-pink-50';
    borderColor = 'border-pink-200';
    textColor = 'text-pink-800';
  } else if (isPeriodDay) {
    bgColor = 'bg-pink-50';
    borderColor = 'border-pink-200';
    textColor = 'text-pink-800';
  } else if (isTestRecommended) {
    bgColor = 'bg-green-50';
    borderColor = 'border-green-200';
    textColor = 'text-green-800';
  }

  return (
    <div className={`mb-4 rounded-lg border ${bgColor} ${borderColor} px-4 py-2`}>
      <div className={`text-center text-xs font-semibold ${textColor}`}>
        Cycle Day {cycleDay}
      </div>
      {isToday && (
        <div className="text-center text-sm font-bold text-[#bfdbfe]">
          Today
        </div>
      )}
      {isPredictedOvulation && (
        <div className={`text-center text-xs font-medium ${textColor}`}>
          Predicted ovulation
        </div>
      )}
      {isPredictedPeriod && (
        <div className={`text-center text-xs font-medium ${textColor}`}>
          Predicted period
        </div>
      )}
      {isTestRecommended && (
        <div className={`text-center text-xs font-medium ${testRecommendedStyle}`}>
          {testRecommendedText}
        </div>
      )}
    </div>
  );
}

export default CalendarDayMenuInfoBox;
